import Hero from "../components/Hero";
import Categories from "../components/Categories";
import Features from "../components/Features";

import { Link } from "react-router-dom";

import { useEffect, useState } from "react";

import { db } from "../firebase";

import {
  collection,
  getDocs
} from "firebase/firestore";


import { useShop } from "../context/ShopContext";

import "./Home.css";



function Home(){


const [products,setProducts] = useState([]);



const {
addToCart,
toggleFavorite,
favorites
}=useShop();




useEffect(()=>{


const getProducts = async()=>{


try{


const snapshot = await getDocs(

collection(db,"products")

);



const data = snapshot.docs.map(item=>({


id:item.id,

...item.data()


}));



setProducts(data);



}

catch(error){

console.log(error);

}



};



getProducts();



},[]);







return(


<div className="home">



{/* Hero */}

<Hero/>





{/* Features */}

<Features/>





{/* Categories */}

<Categories/>







{/* Products */}


<section className="products-section">


<div className="products-header">

<h1>
Featured Items
</h1>


<Link to="/shop" className="view-all">
View All Products →
</Link>


</div>





<div className="products-container">


{

products.slice(0,6).map(product=>(


<div

className="product-card"

key={product.id}

>


<Link

to={`/product/${product.id}`}

className="product-link"

>


<img

src={product.images?.[0] || "/no-image.png"}

alt={product.name}

/>



<h2>
{product.name}
</h2>


</Link>




<h3>
${product.price}
</h3>




<button

className="heart-btn"

onClick={()=>toggleFavorite(product)}

>

{

favorites.some(
(item)=>item.id===product.id
)

?

"❤️"

:

"🤍"

}

</button>



</div>



))


}


</div>


</section>







</div>


);


}



export default Home;